// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:17:00+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            63a0b729648db05c21789f0753a8f51d
//    Signature:      eyJpdiI6IkNaenhWeFhxNEpFYmxqSDRNYit0Qnc9PSIsInZhbHVlIjoiQU9ORzhEdytFazRyU0xlbmJZT1NFd0ZyNjlaNTd3emVtWWV2bTBLNTVHeVo0bStNSnlyTCswYk5rbStWRSs0Qjkzenc4TVJZOGdsZm9RNklQOXhLbHl2N3pxWjlIXC9ZN3c0SDcrbHk0Wm5BVEVVb3ZCVmM1bENLRGFJWUEzZWwzT2o5WGFmUEVKclBEOExrd2tcL050a3JqbXBkaG1JbTZ1REMzbnBaN2owNkl1bUlWVDFuTnhoTysyZXJGTytSR3F1UlhGYVlHbVQzTHpDVHFnMVBtdzdoMmtlSEgrS0hNYTNMWHN0NklLczQ3Nm82b0Jod0xWaU93Ykc3YjZ3dW5iaVRHeEFLQ1dIVll6WXAzaXI0SzZQZnRBd2NIVmZlQm53Nll0UWRnYUVvak9udzBRcDdkTzdZb3laVE9EbXp4S3FBRnRCek9jbnZzbEk5YzNSVE9xa1BreUM2UlRrOThVejJ4XC9DUHlJdUIxYk5NUnJmK3Rzakg2UHZNdWtJN3NPVE9vdTNoSE5CK3JoTEVcL3hjaWVNQnc9PSIsIm1hYyI6IjYxY2NjYzVkZWQ1MzEzNzM4YThjYmMzMzEyNTRjNzE5NzIxZjg0NDI3MGE1NGMxMDE1YTcyNzY4YTZmZDU1ZGIifQ==
// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
